/* Andrea offer packs: actual pack variants and one-unit cart payload. */
(() => {
  const key = '__andreaReferenceProductsV1';
  if (window[key]) { window[key].scan(document); return; }
  const instances = new WeakSet();
  const numericId = value => String(value || '').split('/').pop();
  const money = cents => new Intl.NumberFormat('es-CL', {style:'currency',currency:'CLP',maximumFractionDigits:0}).format(Number(cents)/100);
  function init(root) {
    if (instances.has(root)) return;
    instances.add(root);
    const track = root.querySelector('.rf-gallery-track');
    const galleryItems = [...root.querySelectorAll('.rf-gallery-item')];
    const thumbs = [...root.querySelectorAll('[data-gallery-index]')];
    thumbs.forEach(button => button.addEventListener('click', () => {
      const index = Number(button.dataset.galleryIndex), item = galleryItems[index];
      if (!item) return;
      track.scrollTo({left:item.offsetLeft - track.offsetLeft,behavior:'smooth'});
      thumbs.forEach((b,i) => b.setAttribute('aria-current',String(i===index)));
    }));
    const dialog = root.querySelector('.rf-image-dialog');
    let previousFocus;
    root.querySelectorAll('.rf-open-image').forEach(button => button.addEventListener('click', () => {
      if (!dialog) return;
      previousFocus = button;
      const img=dialog.querySelector('img');img.src=button.dataset.large;img.alt=button.querySelector('img')?.alt || '';
      dialog.showModal();
    }));
    dialog?.querySelector('.rf-close-dialog')?.addEventListener('click',()=>dialog.close());
    dialog?.addEventListener('close',()=>previousFocus?.focus());
    dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
    const form = root.querySelector('.rf-offer-form');
    if (!form) return;
    const error = form.querySelector('.rf-form-error'), submit = form.querySelector('.rf-submit');
    const fail = message => { error.textContent=message;error.hidden=false; };
    let data;
    try { data=JSON.parse(root.querySelector('[data-reference-data]').textContent); }
    catch { submit.disabled=true; root.dataset.referenceError='invalid_json'; return; }
    const config=data.offers || {}, products=new Map((data.product?.variants || []).map(v=>[numericId(v.id),v]));
    const offers=Array.isArray(config.offers)?config.offers:[];
    root.querySelectorAll('.rf-offer-card').forEach(card=>{const o=offers.find(o=>String(o.packVariantId)===card.dataset.packId);if(o){o.label=card.dataset.editorLabel||o.label;o.giftLabel=card.dataset.editorGift||'';o.giftUrl=card.dataset.editorGiftUrl||'';}});
    const components=(config.componentVariants || []).filter(c=>products.has(numericId(c.variantId)));
    const componentMap=new Map(components.map(c=>[numericId(c.variantId),c]));
    const master=form.querySelector('[name="id"]');
    const cards=[...form.querySelectorAll('.rf-offer-card')];
    const offerByPack=new Map(offers.map(o=>[numericId(o.packVariantId),o]));
    const state=new Map();
    const normalOptions=c=>(c.options || []).filter(o=>!/^title$/i.test(o.name)&&o.value!=='Default Title');
    const titleOf=c=>normalOptions(c).map(o=>o.value).join(' / ') || c.label || data.product.title;
    function validPack(offer) {
      const variant=products.get(numericId(offer?.packVariantId));
      const units=Number(offer?.units);
      return config.mode==='pack_variant' && variant && variant.available && Number.isInteger(units) && units>0 && units<=12 &&
        Math.abs(Number(variant.price)/100-Number(offer.expectedTotalCLP))<0.01;
    }
    function allowedFor(offer) {
      const allowed=new Set((offer.componentVariantIds || []).map(numericId));
      return components.filter(c=>!allowed.size || allowed.has(numericId(c.variantId)));
    }
    function makeRow(card,offer,index) {
      const allowed=allowedFor(offer), row=document.createElement('div');
      row.className='rf-unit-row';row.dataset.unit=String(index);
      const number=document.createElement('span');number.textContent='#'+(index+1);row.append(number);
      const names=[...new Set(allowed.flatMap(c=>normalOptions(c).map(o=>o.name)))];
      const effectiveNames=names.length?names:['Modelo'];
      row.style.setProperty('--rf-options-count',String(effectiveNames.length));
      effectiveNames.forEach((name,pos)=>{
        const box=document.createElement('div');box.className='rf-unit-field';
        const label=document.createElement('label'), select=document.createElement('select');
        const controlId='ref-'+root.dataset.referenceSection+'-'+offer.id+'-'+index+'-'+pos;
        label.htmlFor=controlId;label.textContent=name;select.id=controlId;select.dataset.optionName=name;select.setAttribute('aria-label','Pieza '+(index+1)+' — '+name);
        const values=[...new Set(allowed.map(c=>normalOptions(c).find(o=>o.name===name)?.value || c.label))];
        values.forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;select.append(option);});
        select.addEventListener('change',()=>{
          // Preserve the changed choice and select an actually existing combination.
          const current=[...row.querySelectorAll('select')];
          const exact=allowed.find(c=>current.every(input=>(normalOptions(c).find(o=>o.name===input.dataset.optionName)?.value || c.label)===input.value));
          const match=exact || allowed.find(c=>(normalOptions(c).find(o=>o.name===name)?.value || c.label)===select.value);
          if(match) effectiveNames.forEach(other=>{
            const input=[...row.querySelectorAll('select')].find(x=>x.dataset.optionName===other);
            const value=normalOptions(match).find(o=>o.name===other)?.value || match.label;
            if(input&&other!==name) input.value=value;
          });
          resolveRow(row,offer);
        });
        box.append(label,select);row.append(box);
      });
      card.querySelector('[data-unit-container]').append(row);resolveRow(row,offer);
    }
    function resolveRow(row,offer) {
      const inputs=[...row.querySelectorAll('select')];
      inputs.forEach((input,index)=>{
        [...input.options].forEach(option=>{
          option.disabled=index>0 && !allowedFor(offer).some(component=>
            inputs.slice(0,index).every(previous=>(normalOptions(component).find(o=>o.name===previous.dataset.optionName)?.value || component.label)===previous.value) &&
            (normalOptions(component).find(o=>o.name===input.dataset.optionName)?.value || component.label)===option.value
          );
        });
      });
      const match=allowedFor(offer).find(c=>inputs.every(input=>(normalOptions(c).find(o=>o.name===input.dataset.optionName)?.value || c.label)===input.value));
      row.dataset.componentVariantId=match?numericId(match.variantId):'';
      row.classList.toggle('is-unavailable',!match);
      updateSummary();
    }
    function packProperties(offer, rows) {
      const properties={_Oferta:offer.label,Contenido:offer.composition || (offer.units+' unidades'),_Referencia:data.reference};
      if(offer.giftLabel)properties.Regalo=offer.giftLabel;
      if(offer.giftUrl)properties._RegaloDigital=offer.giftUrl;
      rows.forEach((row,index)=>{
        const component=componentMap.get(row.dataset.componentVariantId);
        properties['Pieza '+(index+1)]=titleOf(component);
        properties['_Componente '+(index+1)]=numericId(component.variantId);
      });
      return properties;
    }
    const propertyInputs = new Map();
    function syncPackProperties(offer) {
      const activeCard = cards.find(card => card.dataset.packId === numericId(offer.packVariantId));
      const rows = activeCard ? [...activeCard.querySelectorAll('.rf-unit-row')] : [];
      const complete = rows.filter(row => componentMap.has(row.dataset.componentVariantId));
      const props = packProperties(offer, complete);
      propertyInputs.forEach((input, key) => { if (!(key in props)) { input.remove(); propertyInputs.delete(key); } });
      Object.entries(props).forEach(([key, value]) => {
        let input = propertyInputs.get(key);
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[' + key + ']'; input.dataset.referenceProperty = key; form.append(input); propertyInputs.set(key, input); }
        if (input.value !== String(value)) input.value = String(value);
      });
    }
    function selected() {return offerByPack.get(master?.value);}
    function updateSummary() {
      const offer=selected(), summary=form.querySelector('.rf-selection-summary');
      if(!offer)return;
      syncPackProperties(offer);
      if(!summary)return;
      const variant=products.get(numericId(offer.packVariantId));
      summary.textContent=(offer.composition || offer.label)+' · '+money(variant?.price || 0);
      const gift=form.querySelector('[data-selected-gift]');
      if(gift){gift.hidden=!offer.giftLabel;gift.querySelector('[data-gift-label]').textContent=offer.giftLabel || '';const link=gift.querySelector('[data-gift-download]');link.hidden=!offer.giftUrl;if(offer.giftUrl)link.href=offer.giftUrl;else link.removeAttribute('href');}
    }
    function choose(packId) {
      const offer=offerByPack.get(packId);master.value=packId;
      cards.forEach(card=>{
        const active=card.dataset.packId===packId;card.classList.toggle('is-selected',active);
        const radio=card.querySelector('input[type=radio]');if(radio)radio.checked=active;
      });
      submit.disabled=!validPack(offer);error.hidden=true;updateSummary();
      root.dataset.selectedOffer=offer?.id || '';
      const gifts=root.querySelector('.native-reference-gifts');if(gifts){const unlocked=Number(offer?.units)>=Number(gifts.dataset.shippingMin||1);gifts.querySelector('h3').textContent=(unlocked?gifts.dataset.giftHeading:gifts.dataset.giftHeadingLocked)||gifts.dataset.giftHeading;const state=gifts.querySelector('[data-shipping-state]');if(state)state.textContent=unlocked?'Gratis':(gifts.dataset.shippingLocked||'Bloqueado');}
    }
    if(config.mode!=='pack_variant' || !offers.length || !cards.length) {
      root.dataset.referenceError='offers_missing';submit.disabled=true;return;
    }
    cards.forEach(card=>{
      const offer=offerByPack.get(card.dataset.packId), radio=card.querySelector('input[type=radio]');
      if(!validPack(offer)) {radio.disabled=true;card.dataset.invalidPack='true';return;}
      const allowed=allowedFor(offer);
      if(offer.optionPerUnit && allowed.length) for(let i=0;i<Number(offer.units);i++)makeRow(card,offer,i);
      state.set(offer.id,{card,offer});
      radio.addEventListener('change',()=>choose(card.dataset.packId));
    });
    form.classList.add('is-enhanced');
    const configuredIndex=Number(root.querySelector('[data-native-default-offer]')?.dataset.nativeDefaultOffer||0)-1;
    const preferred=(validPack(offers[configuredIndex])?offers[configuredIndex]:null)||offers.find(o=>o.id===config.defaultOffer&&validPack(o)) || offers.find(validPack);
    if(preferred)choose(numericId(preferred.packVariantId));else{submit.disabled=true;root.dataset.referenceError='no_valid_pack';}
    form.addEventListener('submit',async event=>{
      event.preventDefault();event.stopImmediatePropagation();
      const offer=selected();
      if(!validPack(offer)){fail('La oferta seleccionada no está disponible. Elige otra opción.');return;}
      const card=cards.find(c=>c.dataset.packId===numericId(offer.packVariantId));
      const rows=[...card.querySelectorAll('.rf-unit-row')];
      if(offer.optionPerUnit&&(rows.length!==Number(offer.units)||rows.some(r=>!componentMap.has(r.dataset.componentVariantId)))){
        fail('Elige las opciones de cada pieza del pack.');return;
      }
      const properties=packProperties(offer, rows);
      const original=submit.textContent;submit.disabled=true;submit.textContent='Añadiendo…';error.hidden=true;
      try {
        const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(numericId(offer.packVariantId)),quantity:1,properties}]})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description || 'No se pudo añadir el pack. Inténtalo de nuevo.');
        location.assign('/cart');
      } catch(err) {fail(err.message || 'No se pudo añadir el pack. Inténtalo de nuevo.');submit.disabled=false;submit.textContent=original;}
    },true);
  }
  const scan=scope=>scope.querySelectorAll('[data-reference-section]').forEach(init);
  window[key]={scan};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
})();



(()=>{function init(scope=document){scope.querySelectorAll('[data-oferta-review-list]').forEach(list=>{if(list.dataset.ready)return;list.dataset.ready='true';let count=Number(list.dataset.limit||8);const cards=[...list.children],button=list.parentElement.querySelector('[data-oferta-more]');function show(){cards.forEach((c,i)=>c.hidden=i>=count);button.hidden=count>=cards.length}button?.addEventListener('click',()=>{count+=8;show()});show()});scope.querySelectorAll('[data-oferta-comparison]').forEach(box=>{const range=box.querySelector('input');if(range.dataset.ready)return;range.dataset.ready='1';range.addEventListener('input',()=>box.style.setProperty('--compare',range.value+'%'))})}document.addEventListener('DOMContentLoaded',()=>init());document.addEventListener('shopify:section:load',e=>init(e.target));if(document.readyState!=='loading')init()})();
/* V6 isolated panel carousel; actual pack/cart code above is unchanged. */
(()=>{
 function init(scope=document){
  scope.querySelectorAll('[data-oferta-testimonials]').forEach(box=>{
   if(box.dataset.ready)return;
   const track=box.querySelector('.oferta-testimonial-track'),cards=[...track.children],controls=box.querySelector('[data-oferta-carousel-controls]');
   if(cards.length<2)return;
   box.dataset.ready='true';controls.hidden=false;
   const previous=controls.querySelector('[data-oferta-prev]'),next=controls.querySelector('[data-oferta-next]'),position=controls.querySelector('.oferta-testimonial-position');
   let index=0,frame=0;
   function state(){index=Math.max(0,Math.min(cards.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));position.textContent=(index+1)+' / '+cards.length;previous.disabled=index===0;next.disabled=index===cards.length-1;}
   function move(target){const i=Math.max(0,Math.min(cards.length-1,target));track.scrollTo({left:i*track.clientWidth,behavior:'auto'});state();}
   previous.addEventListener('click',()=>move(index-1));next.addEventListener('click',()=>move(index+1));
   track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(state)},{passive:true});
   track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(index+(event.key==='ArrowRight'?1:-1))}});
   box.addEventListener('shopify:block:select',event=>{const quote=event.target.closest('.oferta-panel-quote');const i=cards.indexOf(quote);if(i>=0)move(i)});
   state();
  });
 }
 document.addEventListener('DOMContentLoaded',()=>init());
 document.addEventListener('shopify:section:load',event=>init(event.target));
 if(document.readyState!=='loading')init();
})();

/* V8: display-only return bar. The pack/cart handler above remains unchanged. */
(()=>{
 function init(scope=document){
  scope.querySelectorAll('.andrea-oferta').forEach(root=>{
   const bar=root.querySelector('[data-oferta-conversion-bar]');
   if(!bar||bar.dataset.ready)return;
   bar.dataset.ready='true';
   const form=root.querySelector('form.product-form'),heading=root.querySelector('h1'),submit=form?.querySelector('.product-form__add-button'),link=bar.querySelector('[data-oferta-bar-link]');
   if(!form||!heading||!submit)return;
   const label=bar.querySelector('[data-oferta-bar-label]'),price=bar.querySelector('[data-oferta-bar-price]');
   const schedule=()=>update();
   function update(){
    if(!root.isConnected)return;
    const liveForm=root.querySelector('form.product-form'),liveSubmit=liveForm?.querySelector('.product-form__add-button');
    if(!liveForm||!liveSubmit){bar.hidden=true;return;}
    const card=liveForm.querySelector('.rf-offer-card.is-selected');
    const currentLabel=card?.querySelector('.rf-offer-copy>strong')?.textContent?.trim();
    const currentPrice=card?.querySelector('.rf-offer-prices>strong')?.textContent?.trim();
    if(currentLabel&&label.textContent!==currentLabel)label.textContent=currentLabel;
    if(currentPrice&&price.textContent!==currentPrice)price.textContent=currentPrice;
    const r=liveSubmit.getBoundingClientRect(),title=heading.getBoundingClientRect();
    const footer=document.querySelector('footer')?.getBoundingClientRect();
    const visible=r.bottom>80&&r.top<innerHeight;
    bar.dataset.ctaVisible=String(visible);
    const ready=!liveSubmit.disabled&&(!liveForm.classList.contains('rf-offer-form')||liveForm.classList.contains('is-enhanced'));
    bar.hidden=!(ready&&title.bottom<80&&!visible&&(!footer||footer.top>innerHeight));
   }
   link.addEventListener('click',event=>{
    event.preventDefault();
    const currentForm=root.querySelector('form.product-form');if(!currentForm)return;
    const target=currentForm.querySelector('.rf-offer-card.is-selected')||currentForm.querySelector('.product-form__variants')||currentForm.querySelector('.product-form__add-button');
    target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    const focus=target.querySelector('input:not([type=hidden]),select')||target;
    focus.focus({preventScroll:true});
   });
   form.addEventListener('change',schedule);
   new MutationObserver(schedule).observe(root,{subtree:true,attributes:true,attributeFilter:['class','disabled'],characterData:true,childList:true});
   window.addEventListener('scroll',schedule,{passive:true});document.addEventListener('scroll',schedule,{passive:true,capture:true});window.addEventListener('resize',schedule,{passive:true});
   if('IntersectionObserver' in window){const visibility=new IntersectionObserver(schedule,{rootMargin:'-80px 0px 0px 0px'});visibility.observe(submit);visibility.observe(heading);const footer=document.querySelector('footer');if(footer)visibility.observe(footer);}
   update();
  });
 }
 document.addEventListener('DOMContentLoaded',()=>init());document.addEventListener('shopify:section:load',e=>init(e.target));if(document.readyState!=='loading')init();
})();
